module.exports = __webpack_public_path__ + "img/illus-play.5a58c067.svg";